import { render } from "./createLotComponent.vue?vue&type=template&id=04a83e43&scoped=true"
import script from "./createLotComponent.vue?vue&type=script&lang=js"
export * from "./createLotComponent.vue?vue&type=script&lang=js"

import "./createLotComponent.vue?vue&type=style&index=0&id=04a83e43&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a83e43"]])

export default __exports__